export const breakpoints = {
    smallMin: 'min-width: 480px',
    mediumMin: 'min-width: 940px',
};

